export default __webpack_public_path__ + "images/b54708c9cbbed69d109301e8b95fae76.png";